// Jobs mock \u2014 extended jobs with geo logs, notes, photos, and time tracking
import { dispatchJobs, unassignedJobs } from "./dispatchMock";

// Phoenix-area mock GPS coordinates per job (close to real addresses)
const jobCoords = {
  "J-10428": { lat: 33.5097, lng: -112.1058 },
  "J-10434": { lat: 33.5097, lng: -112.1058 },
  "J-10440": { lat: 33.4499, lng: -112.0738 },
  "J-10429": { lat: 33.4592, lng: -112.0540 },
  "J-10441": { lat: 33.4933, lng: -112.1102 },
  "J-10430": { lat: 33.5251, lng: -112.1102 },
  "J-10442": { lat: 33.4488, lng: -112.0707 },
  "J-10431": { lat: 33.4953, lng: -112.0560 },
  "J-10432": { lat: 33.4806, lng: -111.9970 },
  "J-10443": { lat: 33.4933, lng: -112.1856 },
  "J-10433": { lat: 33.5440, lng: -112.0660 },
};

function buildLog(job) {
  const coords = jobCoords[job.id] || { lat: 33.4484, lng: -112.0740 };
  const baseDay = job.start ? job.start.slice(0, 10) : new Date().toISOString().slice(0, 10);
  const log = [
    { id: 1, type: "created", label: "Job created", time: `${baseDay}T07:12:00`, by: "Dana Alvarez", icon: "create" },
    { id: 2, type: "scheduled", label: `Scheduled with ${job.tech || "tech"}`, time: job.start || `${baseDay}T08:00:00`, by: "Dana Alvarez", icon: "calendar" },
  ];

  if (["Dispatched", "In Progress", "Completed"].includes(job.status)) {
    log.push({ id: 3, type: "dispatched", label: "Dispatched to technician", time: `${baseDay}T07:45:00`, by: "Dana Alvarez", icon: "send" });
  }
  if (["In Progress", "Completed"].includes(job.status)) {
    log.push({
      id: 4,
      type: "enroute",
      label: "Tech en route",
      time: `${baseDay}T07:52:00`,
      by: job.tech,
      icon: "navigate",
      location: { lat: coords.lat - 0.012, lng: coords.lng - 0.018, label: "Departed depot" },
    });
    log.push({
      id: 5,
      type: "arrived",
      label: "Arrived on site",
      time: job.start || `${baseDay}T08:00:00`,
      by: job.tech,
      icon: "mappin",
      location: { lat: coords.lat, lng: coords.lng, label: job.address },
    });
    log.push({
      id: 6,
      type: "started",
      label: "Work started",
      time: job.start ? offsetTime(job.start, 8) : `${baseDay}T08:08:00`,
      by: job.tech,
      icon: "play",
    });
  }
  if (job.status === "Completed") {
    log.push({
      id: 7,
      type: "finished",
      label: "Work finished",
      time: job.end || `${baseDay}T10:30:00`,
      by: job.tech,
      icon: "check",
      location: { lat: coords.lat + 0.0003, lng: coords.lng + 0.0003, label: job.address },
    });
    log.push({
      id: 8,
      type: "invoiced",
      label: "Invoice sent",
      time: job.end ? offsetTime(job.end, 5) : `${baseDay}T10:35:00`,
      by: job.tech,
      icon: "invoice",
    });
  }
  return log;
}

function offsetTime(iso, minutes) {
  const d = new Date(iso);
  d.setMinutes(d.getMinutes() + minutes);
  return d.toISOString().slice(0, 16);
}

const notesMap = {
  "J-10428": "Customer reports AC unit not cooling for 3 days. Suspected refrigerant leak. Check pressures with manifold gauges before recharge.",
  "J-10430": "Annual safety inspection \u2014 panel + GFCI test + meter check. All passed. Recommended customer upgrade old 100A panel within 2 yrs.",
  "J-10431": "Replace existing 3-ton condenser unit at Building B. Crane required for placement. Confirmed lift booked for 11 AM.",
  "J-10442": "Upgrade from 100A to 200A service panel. Customer informed of 4-hour power interruption. PG&E meter swap pre-coordinated.",
  "J-10440": "Conference room HVAC zone install. Requires after-hours work coordination starting 11 AM. Two-tech crew.",
};

const photosMap = {
  "J-10428": [
    { id: 1, name: "manifold_gauges.jpg", url: "https://images.unsplash.com/photo-1581094288338-2314dddb7ece?w=400", caption: "Manifold gauge readings \u2014 low side 32 psi" },
    { id: 2, name: "outdoor_unit.jpg", url: "https://images.unsplash.com/photo-1635385401066-2f1c69d68d6e?w=400", caption: "Outdoor condenser unit \u2014 visible oil residue at flare joint" },
  ],
  "J-10431": [
    { id: 1, name: "site_prep.jpg", url: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=400", caption: "Site access cleared, crane staging" },
  ],
};

export function buildAllJobs() {
  const base = dispatchJobs.map((j) => ({
    ...j,
    description: notesMap[j.id] || "",
    photos: photosMap[j.id] || [],
    log: buildLog(j),
    coords: jobCoords[j.id] || { lat: 33.4484, lng: -112.0740 },
  }));
  // Include unassigned as scheduled-pending
  const ua = unassignedJobs.map((u) => ({
    ...u,
    techId: null,
    tech: "Unassigned",
    start: null,
    end: null,
    description: "",
    photos: [],
    log: [
      { id: 1, type: "created", label: "Job created \u2014 awaiting dispatch", time: new Date().toISOString().slice(0, 16), by: "Dana Alvarez", icon: "create" },
    ],
    coords: { lat: 33.4484 + Math.random() * 0.05, lng: -112.0740 + Math.random() * 0.05 },
  }));
  return [...base, ...ua];
}

export const STATUS_FLOW = ["Scheduled", "Dispatched", "En Route", "On Site", "In Progress", "Completed"];

export const jobStatusColors = {
  Scheduled: { bg: "#DBEAFE", text: "#1E40AF", dot: "#3B82F6" },
  Dispatched: { bg: "#FEF3C7", text: "#92400E", dot: "#F59E0B" },
  "En Route": { bg: "#FED7AA", text: "#9A3412", dot: "#F97316" },
  "On Site": { bg: "#E0E7FF", text: "#3730A3", dot: "#6366F1" },
  "In Progress": { bg: "#DCFCE7", text: "#166534", dot: "#10B981" },
  Completed: { bg: "#E5E7EB", text: "#374151", dot: "#6B7280" },
  Canceled: { bg: "#FEE2E2", text: "#991B1B", dot: "#EF4444" },
  Unassigned: { bg: "#FEF3C7", text: "#92400E", dot: "#F59E0B" },
};
